export default {
  'component.tagSelect.expand': 'เพิ่มเติม',
  'component.tagSelect.collapse': 'พับเก็บ',
  'component.tagSelect.all': 'All',
  'component.logout.label': 'Logout',
  'component.siteSelector.playerPlaceholder': 'เลือกผู้เล่น...',
  'component.siteSelector.loadingSites': 'กำลังโหลดผู้เล่น...',
  'component.siteSelector.currentSiteLobby': 'เว็บไซต์ล็อบบี้ปัจจุบัน',
  'component.siteSelector.refresh': 'รีเฟรชผู้เล่น',
  'component.siteSelector.playerIdentifier': 'ผู้เล่น',
  'component.gameLaunch.copySuccess': 'คัดลอก URL ไปยังคลิปบอร์ด',
  'component.gameLaunch.copyFailed': 'คัดลอก URL ไม่สำเร็จ',
  'component.gameLaunch.openNewWindow': 'เล่นในหน้าต่างใหม่',
  'component.gameLaunch.copyUrl': 'คัดลอก URL',
  'component.gameLaunch.scanOrPress': 'สแกน QR code หรือคลิกด้านล่างเพื่อเล่น',
  'component.gameLaunch.sessionID': 'รหัสเซสชัน:',
  'component.gameLaunch.goToMonitor': 'ไปที่หน้าจอมอนิเตอร์',
  'component.gameLaunch.copyToken': 'คัดลอกโทเค็น',
  'component.gameLaunch.mobileScanInstruction': 'สแกน QR code ด้วยกล้องโทรศัพท์',
  'component.gameLaunch.mobileTip': 'ใช้แอปกล้องถ่ายรูปเพื่อสแกน',
  'component.gameLaunch.copyForMobile': 'คัดลอก URL สำหรับมือถือ',
  'component.gameLaunch.openBrowser': 'เปิดในเบราว์เซอร์',
  'component.copyAddress': 'คัดลอก address',
  'component.copySuccess': 'คัดลอก address แล้ว',
  'component.endOfList': 'สิ้นสุดรายการ',
  'common.currencyNotSupported': 'ไม่รองรับสกุลเงิน',
  'common.cancel': 'ยกเลิก',
  'common.clear': 'ล้างข้อมูล',
  'common.error': 'เกิดข้อผิดพลาด',
  'common.done': 'เสร็จสิ้น',
  'common.status': 'สถานะ',
  'common.search': 'ค้นหา',
  'common.reset': 'รีเซ็ต',
};
